<template>
  <div class="kanban-board-wrapper">
    <KanbanBoard 
      v-if="boardData"
      :buckets="boardData.buckets"
      :board-title="boardData.title"
    />
    <div v-else class="loading-container">
      <p>Loading board...</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import KanbanBoard from './KanbanBoard.vue'

export default {
  name: 'KanbanBoardWrapper',
  components: {
    KanbanBoard
  },
  computed: {
    ...mapState({
      currentBoard: state => state.kanban.currentBoard
    }),
    boardData() {
      return this.currentBoard
    }
  },
  watch: {
    boardData: {
      handler(newData) {
        if (newData) {
          // Update page title
          this.$store.commit('ui/setPageTitle', newData.title)
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.kanban-board-wrapper {
  height: 100%;
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  
  p {
    color: #666;
    font-size: 16px;
  }
}
</style>
